<template>
  <div>
    <div class="dis-flex p-2">
      <h1 class="text-lg font-bold pad-right pl-3">
        Lección:
      </h1>
      <vue-markdown :source="lesson.title" class="text-lg font-bold"/>
    </div>
    <MobTabs ref="tabs" v-if="tabs.length" :tabs="tabs" class="mt-4" :activeTabProp="activeTab">

      <template #initialPractice>
        <ExerciseResults :moduleIdProp="courseId" :originIdProp="initialPracticeId" :testProp="'lessons'" v-if="initialPracticeShowResults"
                         @skipLesson="goToLesson" @markAsApproved="markAsApproved" :questionsToApprove="initialPracticeQuestionsToApprove"/>
        <PracticeDetail :practicePropId="initialPracticeId" :skipIfFinished="true" :resultsOnTemplate="true" @showResults="showPracticeResults" v-else/>
      </template>

      <template #lesson>
        <div class="border rounded-lg">
          <div>
            <div class="border-t p-1">
              <LessonDescription :description="lesson.text" @goToFinalPractice="goToFinalPractice" :hasFinalPractice="finalPracticeId !== ''"/>
            </div>
          </div>
        </div>

      </template>
      <template #finalPractice>
        <ExerciseResults :moduleIdProp="courseId" :originIdProp="finalPracticeId" :testProp="'lessons'" v-if="finalPracticeShowResults" @skipLesson="goToLesson"
                         @markAsApproved="markAsApproved" :questionsToApprove="finalPracticeQuestionsToApprove" :finalPractice="true"/>
        <PracticeDetail :practicePropId="finalPracticeId" :skipIfFinished="true" :resultsOnTemplate="true" @showResults="showFinalPracticeResults" v-else/>
      </template>
    </MobTabs>
  </div>
</template>

<script>
import { MobTabs, MobSteps } from "@/views/V2/components";
import { getLesson, enrollToLesson } from "@/services/lessons.service";
import mathJaxRender from "@/Utils/mathjax-render.js";
import ExerciseItem from "../components/ExerciseItem.vue";
import LessonExplanation from "./LessonExplanation.vue";
import LessonDescription from "./LessonDescription.vue";
import MarkdownHelp from '@/views/Admin/Components/Utils/MarkdownHelp.vue'
import VueMarkdown from 'vue-markdown'
import PracticeDetail from "@/views/V2/courses/practices/PracticeDetail.vue";
import ExerciseResults from "@/views/V2/courses/ExerciseResults.vue";
import {setQuestionnaireFinished} from "@/services/attemps.service";

export default {
  name: "LessonDetail",
  components: {
    ExerciseResults,
    PracticeDetail,
    MobTabs,
    MobSteps,
    ExerciseItem,
    LessonExplanation,
    LessonDescription,
    VueMarkdown,
    MarkdownHelp,
  },
  data() {
    return {
      lesson: {},
      tabs: [],
      courseId: null,
      activeTab: "",
      initialPracticeId: '',
      initialPracticeShowResults: false,
      initialPracticeQuestionsToApprove: null,
      finalPracticeId: '',
      finalPracticeShowResults: false,
      finalPracticeQuestionsToApprove: null,
      lessonExercise: {}
    };
  },
  async mounted() {
    this.courseId = this.$route.params.id
    await enrollToLesson(this.$route.params.lessonId, this.courseId);

    if (this.$route.params.lessonId) {
      this.lesson = await getLesson(this.$route.params.lessonId);
    }

    const initialPractice = this.lesson.practicesList ? this.lesson.practicesList?.find(practice => practice.step === 1) : null;

    if (initialPractice) {
      this.tabs.push({label: "Práctica inicial", content: "initialPractice"});
      this.initialPracticeId = initialPractice.practices.id.toString();
      if (initialPractice.practices.approve) this.initialPracticeQuestionsToApprove = parseInt(initialPractice.practices.approve);
    }

    await this.markAsApproved();

    this.tabs.push({ label: "Lección", content: "lesson" });

    const finalPractice =  this.lesson.practicesList ? this.lesson.practicesList?.find(practice => practice.step === 2): null;

    if (finalPractice) {
      this.tabs.push({label: "Práctica final", content: "finalPractice"});
      this.finalPracticeId = finalPractice.practices.id.toString();

      if (finalPractice.practices.approve) this.finalPracticeQuestionsToApprove = parseInt(finalPractice.practices.approve);
    }

    mathJaxRender();
  },
  methods: {
    showPracticeResults() {
      this.initialPracticeShowResults = true;
    },
    showFinalPracticeResults() {
      this.finalPracticeShowResults = true;
    },
    async markAsApproved() {
      await setQuestionnaireFinished('lessonDiag', this.$route.params.lessonId, this.courseId);
    },
    async goToLesson() {
      this.$refs.tabs.gotToLessonTab();
    },
    goToFinalPractice() {
      this.$refs.tabs.gotToFinalTab();
    }
  },
  beforeMount() {
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();

    window.MathJax.Hub.Config({
      tex2jax: {
        inlineMath: [
          ["$", "$"],
          ["\\(", "\\)"],
        ],
      },
    });
  },
};
</script>
